import GetSharePointNominations from './GetSharePointNominations'

class GetSharePointNominationById extends GetSharePointNominations {
  requestUrl = `/api/sharePointNomination/${this.getParams().id}`

  formatResponseData = response => ({ ...response.data, type: 'sharepoint-nominations' }) // this type is required to see 'Open In Excel' button
}

export default GetSharePointNominationById
